import React from 'react';
import SvgIcon from "@material-ui/core/SvgIcon";
import { ReactComponent as Logo1 } from "../../images/step1.svg";
import { ReactComponent as Logo2 } from "../../images/step2.svg";
import { ReactComponent as Logo3 } from "../../images/step3.svg";
import { ReactComponent as Logo4 } from "../../images/step4.svg";
import { ReactComponent as Logo5 } from "../../images/step5.svg";
import { ReactComponent as Logo6 } from "../../images/step6.svg";
import { ReactComponent as Tick } from "../../images/tick.svg";
import Typography from '@material-ui/core/Typography';
const divStyle = {zIndex:10}
const titleStyle = {color:'#6C0E21', textAlign:'center'}
const styles = { width:'30px', height:'30px', background:'white', zIndex:10, marginRight:'10px', marginLeft:'20px' }
const styles4 = { width:'30px', height:'30px', background:'white', zIndex:10, marginRight:'10px', marginLeft:'20px' }
const styles5 = { width:'30px', height:'30px', background:'white', zIndex:10, marginRight:'10px', marginLeft:'20px' }
const stylesChi = { width:'30px', height:'30px', background:'white', zIndex:10, marginRight:'10px', marginLeft:'20px' }
const stylesChi5 = { width:'30px', height:'30px', background:'white', zIndex:10, marginRight:'10px', marginLeft:'10px' }
const stylesChi6 = { width:'30px', height:'30px', background:'white', zIndex:10, marginRight:'10px', marginLeft:'10px' }
const stylesChi7 = { width:'30px', height:'30px', background:'white', zIndex:10, marginRight:'10px', marginLeft:'10px' }
const stylesChi2 = { width:'30px', height:'30px', background:'white', zIndex:10, marginRight:'10px', marginLeft:'10px' }
const styles3 = { width:'30px', height:'30px', background:'white', zIndex:10, marginRight:'10px', marginLeft:'28px' }
const Bigstyles = { width:'40px', height:'40px', background:'white', zIndex:10, marginTop:'-3px', marginRight:'10px', marginLeft:'20px' }
const Bigstyles5 = { width:'40px', height:'40px', background:'white', zIndex:10, marginTop:'-3px', marginRight:'10px', marginLeft:'35px' }
const Bigstyles4 = { width:'40px', height:'40px', background:'white', zIndex:10, marginTop:'-3px', marginRight:'10px', marginLeft:'10px' }
const BigstylesChi = { width:'40px', height:'40px', background:'white', zIndex:10, marginTop:'-3px', marginRight:'10px', marginLeft:'10px' }
const BigstylesChi5 = { width:'40px', height:'40px', background:'white', zIndex:10, marginTop:'-3px', marginRight:'10px', marginLeft:'10px' }
const BigstylesChi6 = { width:'40px', height:'40px', background:'white', zIndex:10, marginTop:'-3px', marginRight:'10px', marginLeft:'10px' }
const BigstylesChi7 = { width:'40px', height:'40px', background:'white', zIndex:10, marginTop:'-3px', marginRight:'10px', marginLeft:'10px' }
const Bigstyles3 = { width:'40px', height:'40px', background:'white', zIndex:10, marginTop:'-3px', marginRight:'10px', marginLeft:'28px' }
const emptyStyles = { width:'30px', height:'30px', background:'white', zIndex:10, marginTop:'-3px', zIndex:-1, marginRight:'10px', marginLeft:'10px' }

const CustomStep = (props) => {
    if (props.icon == "1"){
        return (
            <div style={divStyle}>
                <SvgIcon style={props.lang == 'Chi'? props.size == 'big' ? BigstylesChi : stylesChi : props.size == 'big' ? Bigstyles : styles}> <Logo1/> </SvgIcon>
                <Typography style={titleStyle}>{props.title}</Typography>
            </div>
            
        );
    }
    else if (props.icon == "2"){
        return (
            <div style={divStyle}>
                <SvgIcon style={props.lang == 'Chi'? props.size == 'big' ? BigstylesChi : stylesChi2 : props.size == 'big' ? Bigstyles : styles}> <Logo2/> </SvgIcon>
                <Typography style={titleStyle}>{props.title}</Typography>
            </div>
        );
    }
    else if (props.icon == "3"){
        return (
            <div style={divStyle}>
                <SvgIcon style={props.lang == 'Chi'? props.size == 'big' ? BigstylesChi : stylesChi : props.size == 'big' ? Bigstyles : styles} > <Logo3/> </SvgIcon>
                <Typography style={titleStyle}>{props.title}</Typography>
                <Typography style={titleStyle}>{props.title2}</Typography>
            </div>
        );
    }
    else if (props.icon == "4"){
        return (
            <div style={divStyle}>
            <SvgIcon style={props.lang == 'Chi'? props.size == 'big' ? BigstylesChi : stylesChi : props.size == 'big' ? Bigstyles4 : styles4}> <Logo4/> </SvgIcon>
            <Typography style={titleStyle}>{props.title}</Typography>
        </div>
        );
    }
    else if (props.icon == "5"){
        return (
            <div style={divStyle}>
            {/* <SvgIcon style={props.size == 'big' ? Bigstyles5 : styles5}> <Logo5/> </SvgIcon> */}
            <SvgIcon style={props.lang == 'Chi'? props.size == 'big' ? BigstylesChi5 : stylesChi5 : props.size == 'big' ? Bigstyles : styles}> <Logo5/> </SvgIcon>
            <Typography style={titleStyle}>{props.title}</Typography>
            <Typography style={titleStyle}>{props.title2}</Typography>
        </div>
        );
    }
    else if (props.icon == "6"){
        return (
            <div style={divStyle}>
                {/* <SvgIcon style={props.size == 'big' ? Bigstyles : styles}> <Logo6/> </SvgIcon> */}
                <SvgIcon style={props.lang == 'Chi'? props.size == 'big' ? BigstylesChi6 : stylesChi6 : props.size == 'big' ? Bigstyles : styles}> <Logo6/> </SvgIcon>
                <Typography style={titleStyle}>{props.title}</Typography>
            </div>
        );
    }
    else if (props.icon == "7"){
        return (
            <div style={divStyle}>
                <SvgIcon style={props.lang == 'Chi'? props.size == 'big' ? BigstylesChi7 : stylesChi7 : props.size == 'big' ? Bigstyles : styles}> <Tick/> </SvgIcon>
                <Typography style={titleStyle}>{props.title}</Typography>
                <Typography style={titleStyle}>{props.title2}</Typography>
            </div>
        );
    }
    else if (props.icon == "empty"){
        return (
            <div style={emptyStyles}> </div>
        );
    }
    
   
}
export default CustomStep;